import { X } from "lucide-react";

export function Modal({ title, children, onClose, wide = false }) {
  return (
    <div className="fixed inset-0 z-[60] bg-black/80 backdrop-blur-sm flex items-start md:items-center justify-center p-3 overflow-y-auto" onClick={onClose}>
      <div onClick={e => e.stopPropagation()} className={`bg-[#0a0a0a] border border-white/10 ${wide ? "max-w-5xl" : "max-w-3xl"} w-full my-8`}>
        <div className="flex justify-between items-center p-5 border-b border-white/10">
          <div className="font-display text-2xl text-[#F4F1EA]">{title}</div>
          <button onClick={onClose} className="text-[#8a857d] hover:text-[#F4F1EA]"><X size={22}/></button>
        </div>
        <div className="p-5">{children}</div>
      </div>
    </div>
  );
}

export function Field({ label, children }) {
  return (
    <label className="block">
      <div className="font-ui text-[10px] tracking-[0.22em] text-[#8a857d] mb-1">{label}</div>
      {children}
    </label>
  );
}
